import React, { useRef } from "react";
import * as d3 from "d3";

export const useD3 = (renderChartFn, _dependencies) => {
  const ref = useRef(null);

  React.useEffect(() => {
    renderChartFn(d3.select(ref?.current));
    return () => {};
  }, [renderChartFn]);
  return ref;
};
